import React, { useCallback, useMemo } from 'react';
import { useController } from 'react-hook-form';
import { formatDefaultValueSelect } from '../../utils/mask';
import {
    FormInputLabel,
    FormItemContainer,
    FormSelect,
} from '../StyledComponents';
import { parseStringToJson } from "../../utils/utils";

export const DEFAULT_VALUE_SELECIONE = 'Selecione';

const Select = ({
                    name,
                    control,
                    rules,
                    label,
                    placeholder,
                    onChangeDefault,
                    onPress,
                    returnItem,
                    returnAsObject,
                    notRequired = false,
                    requiredColor = '#0061C6',
                    options,
                    capitalize,
                    defaultName,
                    defaultValue,
                    containerWidth = null,
                    inputWidth = null,
                    width = 'auto',
                    formatOptionLabel = null,
                    formatValueOnChange = null,
                    isLoading = false,
                    defaultFirstValue = DEFAULT_VALUE_SELECIONE,
                    icon,
                    borderRadius = '',
                    ...props
                }) => {
    const {
        field: {value, onChange},
        fieldState: {error},
    } = useController({control, name, rules});

    const renderError = useMemo(() => {
        return error && error.message ? (
            <p
                style={{
                    color: error?.message ? '#F5365C' : '#000000',
                }}
            >
                {error?.message}
            </p>
        ) : null;
    }, [error]);

    const capitalizeText = useCallback(
        (option) => {
            const optionProperty = typeof option?.nome === 'object' ? JSON.stringify(option?.nome) : option[defaultName] || option?.nome || option;

            if (formatOptionLabel) {
                return formatOptionLabel(optionProperty);
            }

            if (capitalize) {
                return formatDefaultValueSelect(optionProperty);
            }

            return optionProperty;
        },
        [capitalize, formatOptionLabel, defaultName]
    );

    const renderOptions = useMemo(() => {
        return options?.map((option, idx) => (
            <option
                key={`${idx}`}
                value={(returnItem && JSON.stringify(option)) || option[defaultValue] || option.id || option}
                title={option?.nome || option[defaultName] || option}
            >
                {capitalizeText(option)}
            </option>
        ));
    }, [capitalizeText, defaultName, defaultValue, options, returnItem]);

    return (
        <FormItemContainer width={width}>
            {(!!label || !!placeholder) && (
                <FormInputLabel>
                    <label>
                        {label ?? placeholder}{' '}
                        {!notRequired && (
                            <strong style={{color: requiredColor}}>*</strong>
                        )}
                    </label>
                </FormInputLabel>
            )}
            {
                <>
                    <FormSelect
                        {...props}
                        value={typeof value === 'object' ? JSON.stringify(value) : value}
                        placeholder={placeholder}
                        onChange={(event) => {
                            if (returnAsObject) {
                                onChange(parseStringToJson(event.target.value))
                                return;
                            }
                            if (onChangeDefault) {
                                onChangeDefault(event.target.value);
                                return;
                            }
                            if (formatValueOnChange) {
                                onChange(formatValueOnChange(event.target.value));
                              return;
                            }
                            onChange(event.target.value);
                        }}
                        borderRadius={borderRadius}
                    >
                        <option value={''}>
                            {isLoading ? 'Carregando informações....' : defaultFirstValue}
                        </option>
                        {!isLoading && renderOptions}
                    </FormSelect>

                    {!!icon && (
                        <div style={{position: 'relative'}}>
                            <div
                                style={{
                                    position: 'absolute',
                                    textAlign: 'center',
                                    left: '88%',
                                    bottom: '6px',
                                }}
                            >
                                {icon()}
                            </div>
                        </div>
                    )}
                    {renderError}
                </>
            }
        </FormItemContainer>
    );
};

export default Select;
